module.exports = __webpack_public_path__ + "assets/e66c2803ed56d21635aada07a4752050.png";